"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddToBasketAnalytics = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var _analyticsData = require("@ori/analytics-data");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _navigation = require("../../../context/navigation");
var _useSendNavigationSignal = require("./useSendNavigationSignal");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const useAddToBasketAnalytics = () => {
  const {
    value
  } = (0, _navigation.useSearchInput)();
  const {
    sendNavigationSignal
  } = (0, _useSendNavigationSignal.useSendNavigationSignal)({
    query: value,
    type: 'cart'
  });
  const onAddToBasket = (0, _react.useCallback)(event => {
    const {
      detail
    } = event;
    if (detail.placement !== _analyticsData.Placement.TopNavigationSearchSuggestions) {
      return;
    }
    void sendNavigationSignal(detail.position ?? 0, detail.itemCode);
  }, [sendNavigationSignal]);
  const events = (0, _react.useMemo)(() => [{
    name: AddToBasketEvent.Name,
    listener: onAddToBasket
  }], [onAddToBasket]);
  (0, _presentationHooks.useGlobalEvents)(events);
};
exports.useAddToBasketAnalytics = useAddToBasketAnalytics;